import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        user: {}, // user: {userId:'', userName:'', userPic:''},
        users: [],
    },
    getters: {
    },
    mutations: {
        userInfo (state, userData) {
            state.user = userData
            // localStorage.setItem('user', JSON.stringify(userData))
        },
        usersInfo (state, usersData) {
            // stateへ保存
            state.users = usersData
            // Json文字列に変換しLocalStorageへ保存
            // localStorage.setItem('users', JSON.stringify(usersData))
        },
    },
    actions: {
    }
})

export default store